import {useMemo} from 'react';
import {useUserCan, useUserCanAny} from '../../../hooks/useUserCan';
import {useRqChildCompanies} from '../../../react_query/messages/sharing';

export const useDistrictMessageSharingAccess = (companyId: number) => {
  const isAdmin = useUserCanAny('is-admin');
  const isPartner = useUserCanAny('partner');
  const hasMessageSharingAccess = useUserCan(
    'district-hierarchy:view,district-message-sharing:update',
  );
  const hasSharingPermission = isAdmin || isPartner || hasMessageSharingAccess;

  const {data: childCompanies, isLoading} = useRqChildCompanies(
    companyId,
    hasSharingPermission && Boolean(companyId),
  );

  const hasActiveChildCompanies = useMemo(() => {
    return (childCompanies || []).some(company => company.is_active);
  }, [childCompanies]);

  return {
    canManageDistrictSharing: hasSharingPermission && hasActiveChildCompanies,
    hasSharingPermission,
    hasActiveChildCompanies,
    isLoadingChildCompanies: isLoading,
  };
};
